import { useCallback, useId, useLayoutEffect, useState } from 'react';

/**
 * Used to generate an id, and after render, check if that id is rendered so we know
 * if we can use it in places such as labelledby.
 *
 * @return The generated id, or undefined if not found in the DOM.
 *
 * Inspired by https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/utils/src/useId.ts#L115
 */
export function useSlotId(): string | undefined {
  const id = useId();
  const [resolvedId, setResolvedId] = useState<string | undefined>(id);
  const updateId = useCallback(() => {
    if (document.getElementById(id)) {
      setResolvedId(id);
    } else {
      setResolvedId(undefined);
    }
  }, [id]);

  useLayoutEffect(updateId, [updateId]);

  return resolvedId;
}
